import { Link } from 'react-router-dom';

export default function CTASection({ settings = {} }) {
  return (
    <section className="py-20 bg-gray-900 text-white">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-4">
          {settings.cta_headline || 'Ready to See Real Results?'}
        </h2>
        <p className="text-xl text-gray-300 max-w-3xl mx-auto mb-8">
          {settings.cta_subheadline || "We take on 3 new clients per quarter to ensure dedicated attention. Book your free growth audit before spots fill up."}
        </p>
        <Link to="/growth-audit" className="bg-blue-600 hover:bg-blue-700 text-white py-4 px-10 rounded-full font-medium text-lg transition inline-block">
          {settings.cta_button_text || 'Get Your Free Growth Audit'}
        </Link>
        <p className="text-gray-500 text-sm mt-4">No commitment required. We'll assess your project and share honest feedback.</p>
      </div>
    </section>
  );
}
